import React from 'react';
import { Reveal } from './ui/Reveal';
import { routeSteps } from '../data/content';
export function NotJustInfoSection() {
  return <section aria-labelledby="ruta-bases" className="bg-navy-deep" data-id="element-124" data-mp="z04o5lkqcfez">
      <div className="mx-auto max-w-page px-3 py-5 text-center sm:px-6 sm:py-7" data-id="element-125" data-mp="1dnpq3c5vc8lb">
        <Reveal data-id="element-126" data-mp="18x0yzxy3pdmp">
          <h2 id="ruta-bases" className="mx-auto max-w-3xl font-display text-lg uppercase leading-[1.06] text-white sm:text-2xl lg:text-3xl" data-id="element-127" data-mp="18wheqakzad5i">
            Esto no es solo información sobre paneles solares.
          </h2>
          <p className="mt-0.5 font-condensed text-lg uppercase tracking-wide text-solar sm:text-2xl" data-id="element-128" data-mp="1hrfcbuz2me36">
            Es una ruta para construir tus bases en energía fotovoltaica.
          </p>
        </Reveal>

        <ul className="mx-auto mt-2.5 grid max-w-4xl gap-1.5 text-left sm:grid-cols-2 lg:grid-cols-3" data-id="element-129" data-mp="28auoctb5osb">
          {routeSteps.map((step, i) => <Reveal key={step.text} as="li" delay={i * 0.03} className="flex items-center gap-2 rounded-md border border-white/15 bg-white/5 px-2.5 py-2 font-body text-[0.78rem] font-semibold text-white sm:text-[0.82rem]" data-id="element-130" data-mp="3tfnaanejlu64" data-mpi={i}>
              <span aria-hidden="true" className="text-base" data-id="element-131" data-mp="2j46xd28d5d04">
                {step.icon}
              </span>
              {step.text}
            </Reveal>)}
        </ul>

        <Reveal delay={0.08} className="mx-auto mt-3 max-w-2xl" data-id="element-132" data-mp="2svktr150pwp1">
          <p className="font-body text-[0.8rem] leading-snug text-white/80 sm:text-sm" data-id="element-133" data-mp="2sxdzme7t4cvz">
            Tu objetivo no es simplemente terminar el contenido.{' '}
            <span className="font-bold text-solar" data-id="element-134" data-mp="31x1458vu1yt9">
              Es poder mirar un sistema fotovoltaico y comenzar a entender qué
              estás viendo, cómo funciona y cómo se estructura un proyecto
              solar.
            </span>
          </p>
        </Reveal>
      </div>
    </section>;
}